export default __webpack_public_path__ + "static/media/FlechaBoton3.5b5d1056.svg";